<template>
  <div class="c-search-bar c:row-between-center">
    <img class="c-search-bar-icon" src="@/assets/icons/search.svg" alt="" />
    <input
      class="c-search-bar-input"
      type="search"
      :value="value"
      :placeholder="placeholder"
      @focus="(focused = true), $emit('focus')"
      @input="onInput"
      @change="onChange"
      @keydown.enter="onSearch"
      @blur="onBlur"
    />
    <div v-if="clearable" class="clear-icon" @click="throttledOnClearClick">
      <van-icon name="clear" color="#a7a7a7" size="0.8rem" />
    </div>
  </div>
</template>

<script>
import { throttle } from "@/utils";
import { sleep } from "@/utils/timer";

export default {
  emits: ["input", "change", "search", "clear"],
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "搜索",
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    clearable() {
      // return this.value !== "" && this.focused;
      return this.value !== "";
    },
  },
  // mounted() {
  //   console.log("CSearchBar mounted modelValue", this.modelValue);
  //   console.log("CSearchBar mounted value", this.value);
  // },
  created() {
    this.throttledOnClearClick = throttle(this.clear, 500);
  },
  methods: {
    clear() {
      // console.log("onClear");
      this.$emit("input", "");
      this.$emit("change", "");
      this.$emit("clear");
    },
    onInput(event) {
      // console.log("onInput", event.target.value);
      this.$emit("input", event.target.value);
    },
    onChange(event) {
      // console.log("onChange", event.target.value);
      this.$emit("change", event.target.value);
    },
    onSearch() {
      // console.log("onSearch", this.value);
      this.$emit("search");
    },
    async onBlur() {
      this.$emit("blur");
      await sleep(0);
      this.focused = false;
    },
  },
};
</script>
<style lang="less" scoped>
.c-search-bar {
  gap: 8/20rem;

  width: 100%;
  height: 36/20rem;
  border-bottom: 1px solid #000000;

  &-icon {
    width: 12/20rem;
    height: 12/20rem;
  }

  &-input {
    flex: 1;
    width: 0;
    height: 20/20rem;
    font-size: 14/20rem;
    line-height: 20/20rem;
    letter-spacing: 0.4px;
    padding: 0 !important;
  }
  &-input::placeholder {
    font-weight: 400;

    color: #a7a7a7;
  }

  .clear-icon {
    width: 24/20rem;
    height: 16/20rem;
    text-align: right;
    font-size: 0;
  }
}
</style>
